import { render, staticRenderFns } from "./TextWithButton.vue?vue&type=template&id=c4ba40f8&scoped=true"
import script from "./TextWithButton.vue?vue&type=script&lang=js"
export * from "./TextWithButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ba40f8",
  null
  
)

export default component.exports